"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dialColors = exports.dialSizes = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      position: "relative"
    },
    dial: {},
    bottom: {
      color: theme.palette.grey[200]
    },
    top: {
      position: "absolute",
      top: 0,
      left: 0
    },
    circle: {
      strokeLinecap: 'round'
    },
    small: {
      borderRadius: 2,
      height: 4,
      "& .MuiLinearProgress-bar": {
        borderRadius: 2
      }
    },
    medium: {
      borderRadius: 4,
      height: 6,
      "& .MuiLinearProgress-bar": {
        borderRadius: 4
      }
    },
    error: {
      "& .MuiCircularProgress-svg": {
        color: theme.palette.error.main
      }
    },
    success: {
      "& .MuiCircularProgress-svg": {
        color: theme.palette.success.main
      }
    },
    warning: {
      "& .MuiCircularProgress-svg": {
        color: theme.palette.warning.main
      }
    }
  };
});
var sizes = {
  xsmall: {
    size: 32,
    thickness: 3
  },
  small: {
    size: 44,
    thickness: 3
  },
  medium: {
    size: 72,
    thickness: 2
  },
  large: {
    size: 112,
    thickness: 2
  }
};
/**
 *
 * ** This module is used to display data in a meaningful and visual way. **
 *
 * Dial is commonly used to indicate the usage or progress that has been made. Animation can be used to help the user understand what the visual data indicates. For example, animation can show the full dial burning down on page launch to indicate the coloured part is what is remaining. Data information can be displayed in the middle. All dials can be used on all breakpoints.
 *
 */

var Dial = function Dial(_ref) {
  var _classNames, _classNames2;

  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "error" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: styles.root
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    value: 100,
    variant: "static",
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.dial, true), _defineProperty(_classNames, styles.bottom, true), _classNames)),
    size: sizes[size].size,
    thickness: sizes[size].thickness
  }), /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    value: value,
    variant: "static",
    className: (0, _classnames.default)((_classNames2 = {}, _defineProperty(_classNames2, styles.dial, true), _defineProperty(_classNames2, styles.top, true), _defineProperty(_classNames2, styles[color], true), _classNames2)),
    classes: {
      circle: styles.circle
    },
    size: sizes[size].size,
    thickness: sizes[size].thickness
  }));
};

Dial.propTypes = {
  /** The value of the dial */
  value: _propTypes.default.number.isRequired,

  /** The available sizes of the dial (32px, 44px, 74px, 106px) */
  size: _propTypes.default.oneOf(["xsmall", "small", "medium", "large"]),

  /** The available color of the dial data visual */
  color: _propTypes.default.oneOf(["error", "success", "warning"])
};
Dial.defaultProps = {
  size: "medium",
  color: "error"
};
var dialSizes = ["xsmall", "small", "medium", "large"];
exports.dialSizes = dialSizes;
var dialColors = ["error", "success", "warning"];
exports.dialColors = dialColors;
var _default = Dial;
exports.default = _default;